import React from 'react';
import { ActivityIcon, BookOpenIcon, CalendarDaysIcon, ClipboardListIcon, ClockIcon, LayersIcon } from 'lucide-react';
import { differentiators } from '../data/content';
import { Mark, SectionTitle } from './ui/Section';
const icons = {
  book: BookOpenIcon,
  clock: ClockIcon,
  activity: ActivityIcon,
  calendar: CalendarDaysIcon,
  clipboard: ClipboardListIcon,
  layers: LayersIcon
};
export function Differentiators() {
  return <section className="bg-white px-4 py-12 md:py-16" data-id="element-43" data-mp="zebt2kwu561b">
      <div className="mx-auto max-w-6xl" data-id="element-44" data-mp="13dt03irwub8l">
        <SectionTitle data-id="element-45" data-mp="13eujqbmzs61x">
          This isn't just another collection of massage techniques.{' '}
          <Mark data-id="element-46" data-mp="18buj63pc6ak2">It's a complete, organized professional sports massage system.</Mark>
        </SectionTitle>

        <ul className="mt-10 grid gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-47" data-mp="1ddtnpgwtbdil">
          {differentiators.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.title} className="flex gap-4" data-id="element-48" data-mp="2oq48b01ek3by">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-blue-700/10" data-id="element-49" data-mp="bp3wli9awy8e">
                  <Icon className="h-5 w-5 text-blue-700" aria-hidden="true" data-id="element-50" data-mp="7oaamuff5ti5" />
                </span>
                <div data-id="element-51" data-mp="2n32gu9d6say">
                  <h3 className="text-sm font-black uppercase leading-tight text-blue-950" data-id="element-52" data-mp="2mb45boduggz">{item.title}</h3>
                  <p className="mt-1.5 text-sm leading-snug text-slate-600" data-id="element-53" data-mp="3twjktjgrhqng">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}